export default __webpack_public_path__ + "static/selfapp-app-mobile-b32d8af63b6317a46d8d2fb3ab665bb2.jpg";